export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;
  const $widgetHTML = $(`#${widgetName}`);

  function modifyTitle(data) {
    const { Title: text } = data.items[0];
    const h1 = `<h1 class="card-widget-title" aria-label="${text}">${text}</h1>`;
    $widgetHTML.find('span.card-widget-title').remove();
    $widgetHTML.find('.card-content').prepend(h1);
  }

  return saffire.widgets.cardWidget($widgetHTML, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      const button = $widgetHTML.find('.moreButton');
      if (!hasData) {
        $widgetHTML.remove();
      } else {
        modifyTitle(data);
        button.addClass('button');
      }
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [''],
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'LEARN MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false,
  });
}
